import React, { useEffect, useRef } from 'react';

import { Space } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import type { EventPayload } from '../../helpers/sendMessageToParentWindow';
import { generateSendMessageToParentWindow } from '../../helpers/sendMessageToParentWindow';
import { useSettingCommunicationBetweenWindows } from '../../hooks/settingCommunicationBetweenWindows';
import type { EnrichedOfferFromBff } from '../../interfaces/offers';
import { Pixels } from '../Pixels';

import { Block } from './components/Block/Block';
import styles from './vertical-widget.module.scss';

export const VerticalWidget = ({ offers, iframeId }: { offers: EnrichedOfferFromBff[]; iframeId: string }) => {
  const cx = useStyles(styles);
  const componentRef = useRef<HTMLDivElement>();

  const sendMessageToParentWindow = generateSendMessageToParentWindow(iframeId);

  const { isMobile } = useSettingCommunicationBetweenWindows({
    componentRef,
    sendMessageToParentWindow,
  });

  const loadedOffersCount = offers?.length;

  useEffect(() => {
    if (loadedOffersCount) {
      sendMessageToParentWindow({ type: 'itemsCount', itemsCount: loadedOffersCount });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedOffersCount]);

  const handleClickBlock = (event: EventPayload) =>
    sendMessageToParentWindow({
      type: 'pushEvent',
      event,
    });

  const handleViewBlock = (event: EventPayload) => {
    sendMessageToParentWindow({
      type: 'pushEvent',
      event,
    });
  };

  return (
    <div ref={componentRef} className={cx({ [styles.parentWindowDesktop]: !isMobile })}>
      <Pixels />
      <Space direction="vertical" size={36}>
        {offers.map((offer) => (
          <Block
            key={offer._id}
            offer={offer}
            isMobile={isMobile}
            handleViewBlock={handleViewBlock}
            handleClickBlock={handleClickBlock}
          />
        ))}
      </Space>
    </div>
  );
};
